<div class="modal-preview__overlay" (click)="hide()" [ngClass]="{ 'modal-preview__overlay--open': isOpen }"></div>
<div class="modal-preview" [ngClass]="{ 'modal-preview--open': isOpen }">
  <div class="modal-preview__dialog">
    <div class="modal-preview__content">
      <div class="modal-preview__header">
        <h5 class="modal-preview__title">{{ 'PHOTO_PREVIEW.HEADER' | translate }}</h5>
        <button type="button" class="modal-preview__close" (click)="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-preview__body">
        @if (!src) {
          <div class="modal-preview__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">{{ 'PHOTO_PREVIEW.LOADING' | translate }}</span>
            </div>
          </div>
        }
        @if (src) {
          <button type="button" class="modal-preview__image" (click)="openImageInNewTab()">
            <astral-image-preview [src]="src" alt="Image Preview"></astral-image-preview>
          </button>
        }
      </div>
      @if (src) {
        <div class="modal-preview__download">
          <a [href]="src" [download]="fileName">{{ 'PHOTO_PREVIEW.DOWNLOAD' | translate }}</a>
        </div>
      }
    </div>
  </div>
</div>
